import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ShadowApp } from './ShadowApp';
import { loadRuntimeConfig, getApiBaseUrl } from './lib/runtime-config';
import './styles/tokens.css';
import './styles/global.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Missing #root');

// Fetch runtime config before rendering so getCachedConfig() returns real values
// to components that read deployment URLs (e.g. NewKeyReveal's Claude Desktop
// snippet). If /config fetch fails, the SPA still boots — the cache stays null
// and components fall back to sensible defaults / empty strings.
//
// We MUST await the config fetch in standalone-SPA mode because AuthProvider
// reads the resolved API base URL via getApiBaseUrl() at render time. If
// AuthProvider mounts before the bootstrap completes, the api-client uses an
// empty baseUrl and the SPA calls its own origin (sa-admin) instead of the
// deployment's API host (sa-api) — every auth POST then returns 405 because
// nginx doesn't serve the /auth/* routes.
const main = async () => {
  await loadRuntimeConfig().catch((err) => {
    console.warn('[shiftagent] runtime config fetch failed:', err);
  });
  createRoot(rootEl).render(
    <StrictMode>
      <ShadowApp apiUrl={getApiBaseUrl()} />
    </StrictMode>,
  );
};
void main();
